import { render, staticRenderFns } from "./newKeyStudents.vue?vue&type=template&id=3c4235c3&scoped=true"
import script from "./newKeyStudents.vue?vue&type=script&lang=js"
export * from "./newKeyStudents.vue?vue&type=script&lang=js"
import style0 from "./newKeyStudents.vue?vue&type=style&index=0&id=3c4235c3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c4235c3",
  null
  
)

export default component.exports